<template>
  <div class="coupon">
    <div class="wrap">
      <!--<div class="card-bag" v-if="cardBagShow" @click="toCardBag">我的卡包</div>-->
      <div class="form">
        <div class="form-content">
          <van-form ref="form" @submit="subSuccess">
            <ul class="form-ul">
              <li>
                <van-field
                  v-model="form.code"
                  placeholder="请输入兑换码"
                  :rules="rules.code"
                  name="pattern"
                  :maxlength="16"
                  label="兑换码："
                  @blur="redeemChange"
                ></van-field>
              </li>
              <li>
                <van-field
                  v-model="form.phone"
                  placeholder="请输入手机号"
                  :maxlength="11"
                  :rules="rules.phone"
                  label="手机号："
                  type="tel"
                  :disabled="phoneInputDisable"
                ></van-field>
              </li>
              <li class="tow-para">
                <van-field
                  v-model="form.captcha"
                  placeholder="请输入验证码"
                  :maxlength="6"
                  :rules="rules.captcha"
                  label="验证码："
                  type="number"
                ></van-field>
                <div
                  :class="
                    subBtnDisable
                      ? 'btn is-disable'
                      : btn.disable
                      ? 'btn is-disable'
                      : 'btn'
                  "
                  @click="getCode"
                >
                  {{
                    subBtnDisable
                      ? '获取验证码'
                      : btn.disable
                      ? `${btn.num}s`
                      : '获取验证码'
                  }}
                </div>
              </li>
            </ul>
          </van-form>
        </div>
        <div
          :class="subBtnDisable ? 'btn-sub is-disable' : 'btn-sub'"
          @click="submit"
        >
          激活
        </div>
      </div>
      <div class="rule">
        <h2><span>兑换规则</span></h2>
        <ul>
          <li>1、请详细核对兑换的手机号，必须11位数正确的手机号码。</li>
          <li>2、请在有效期内使用，过期将无法使用，不退货不补偿。</li>
          <li>
            3.如遇问题，可拨打客服热线：<a href="tel:4006627299">4006627299</a>
          </li>
        </ul>
      </div>
    </div>
    <van-dialog
      v-model="dialog.show"
      :showConfirmButton="false"
      :closeOnClickOverlay="false"
      class="cus-dialog"
    >
      <h3 class="title">温馨提示！</h3>
      <div class="msg">
        <p v-html="dialog.msg"></p>
        <ul
          v-if="
            dialog.ulMsgShow &&
              dialog.redeCodeStatus == 2 &&
              dialog.gcAttribute == 3
          "
        >
          <li>
            <span>充值商品：</span>
            <em>{{ dialog.goodsName }}</em>
          </li>
          <li>
            <span>充值账号：</span>
            <em>{{ dialog.account }}</em>
          </li>
          <li>
            <span>充值时间：</span>
            <em>{{
              this.common.formatDate(dialog.rechargeTime, '{y}-{m}-{d}')
            }}</em>
          </li>
        </ul>
        <ul
          v-if="
            dialog.ulMsgShow &&
              dialog.redeCodeStatus === 2 &&
              dialog.gcAttribute != 3
          "
        >
          <li>
            <span>兑换商品：</span>
            <em>{{ dialog.goodsName }}</em>
          </li>
          <li>
            <span>手机号码：</span>
            <em>{{ dialog.account }}</em>
          </li>
          <li>
            <span>兑换时间：</span>
            <em>{{ this.common.formatDate(dialog.excTime, '{y}-{m}-{d}') }}</em>
          </li>
        </ul>
        <ul v-if="dialog.ulMsgShow && dialog.redeCodeStatus === 3">
          <li>
            <span>过期时间：</span>
            <em>{{
              this.common.formatDate(dialog.expireTime, '{y}-{m}-{d}')
            }}</em>
          </li>
        </ul>
      </div>
      <div class="confirm" @click="dialogSure">确认</div>
    </van-dialog>
  </div>
</template>
<script>
import { checkCode, getVerifyCode, coatingSend } from '@/api'
export default {
  inject: ['reload'],
  data() {
    const phoneVal = val => {
      return /^1\d{10}$/.test(val)
    }
    return {
      cardBagShow: this.$route.query.cb == 1,
      form: {
        code: this.$route.query.code || undefined,
        phone: '',
        captcha: '',
        id: ''
      },
      rules: {
        code: [{ required: true, message: '请输入兑换码' }],
        phone: [{ validator: phoneVal, message: '请输入正确手机号' }],
        captcha: [{ required: true, message: '请输入验证码' }]
      },
      btn: {
        disable: false,
        timer: null,
        num: 60
      },
      dialog: {
        show: false,
        msg: '',
        ulMsgShow: false
      },
      subBtnDisable: true,
      phoneInputDisable: false,
      activeSuccess: false
    }
  },
  created() {
    if (this.$route.query.code) {
      this.CheckCode()
    }
  },
  methods: {
    toCardBag() {
      // 跳转卡包页面
      window.location.href = process.env.VUE_APP_HTTP_KB
    },
    initForm() {
      this.form.phone = ''
      this.form.id = ''
      this.form.captcha = ''
    },
    CheckCode() {
      this.subBtnDisable = true
      const obj = {
        code: this.form.code,
        redeemCodePageType: 2
      }
      checkCode(obj).then(res => {
        if (res.code === 0) {
          const data = res.data
          if (data.routeFlag === 0) {
            // if (data.phone){
            //     this.form.phone = data.phone;
            //     this.phoneInputDisable = true;
            // } else{
            //     this.phoneInputDisable = false;
            // }
            this.form.id = data.id
            this.subBtnDisable = false
          } else if (data.routeFlag === 2) {
            this.initForm()
            this.dialog.msg = res.message
            for (const k in data) {
              this.dialog[k] = data[k]
            }
            this.dialog.show = true
            this.dialog.ulMsgShow = true
          } else {
            this.initForm()
            this.dialog.msg = '兑换类型不匹配，无法兑换！'
            this.dialog.show = true
          }
        } else {
          this.initForm()
          this.phoneInputDisable = false
          this.dialog.show = true
          if (res.data && res.data.checkRedeemCodeErrorCode) {
            switch (res.data.checkRedeemCodeErrorCode.code) {
              case -1:
                {
                  this.dialog.msg = '兑换码不存在'
                }
                break
              case 1:
                {
                  this.dialog.msg = '该兑换码在兑换中'
                }
                break
              case 2:
                {
                  this.dialog.msg = '该兑换码正在售后中，无法兑换！'
                }
                break
              case 3:
                {
                  this.dialog.msg = '该兑换码已退款退券，无法兑换！'
                }
                break
              case 4:
                {
                  this.dialog.msg = '兑换码已禁用，无法兑换！'
                }
                break
              case 5:
                {
                  this.dialog.msg = '该兑换码已使用'
                }
                break
              case 6:
                {
                  this.dialog.msg = '兑换时间已过期'
                }
                break
              case 7:
                {
                  this.dialog.msg = `兑换时间未开始，有效兑换时间：<br>${this.common.formatDate(
                    res.data.effectiveStartTime,
                    '{y}-{m}-{d}'
                  )}~${this.common.formatDate(
                    res.data.effectiveEndTime,
                    '{y}-{m}-{d}'
                  )}`
                }
                break
              case 8:
                {
                  this.dialog.msg = '兑换类型不匹配'
                }
                break
              case 9:
                {
                  this.dialog.msg = '兑换页面类型不匹配'
                }
                break
              case 10:
                {
                  this.dialog.msg = '兑换手机号码信息不存在'
                }
                break
              case 11:
                {
                  this.dialog.msg = '此兑换码已激活'
                }
                break
              default:
                {
                  this.dialog.msg = res.message
                }
                break
            }
          } else {
            this.dialog.msg = res.message
          }
        }
      })
    },
    redeemChange(event) {
      // 兑换码变化
      if (this.form.code) {
        this.CheckCode()
      }
    },
    submit() {
      // 立即兑换
      if (!this.subBtnDisable) {
        this.$refs.form.submit()
      }
    },
    subSuccess() {
      // 表单验证成功后事件
      const { id, phone, captcha, code } = this.form
      const obj = {
        code: captcha,
        id,
        phone,
        redeemCode: code
      }
      coatingSend(obj).then(res => {
        if (res.code === 0) {
          this.dialog.msg = '商品已下发，请注意查收短信'
          this.dialog.show = true
          this.activeSuccess = true
        } else {
          this.dialog.msg = res.message
          this.dialog.show = true
        }
      })
    },
    getCode() {
      // 获取验证码
      if (!this.btn.disable && !this.subBtnDisable) {
        this.$refs.form.validate('pattern').then(val => {
          // 验证通过触发事件
          const obj = {
            id: this.form.id,
            phone: this.form.phone
          }
          getVerifyCode(obj).then(res => {
            if (res.code === 0) {
              this.btn.num = 60
              this.btn.disable = true
              this.btn.timer = setInterval(() => {
                this.btn.num--
                if (this.btn.num <= 0) {
                  this.btn.disable = false
                  this.btn.timer = null
                }
              }, 1000)
            } else {
              alert(res.message)
            }
          })
        })
      }
    },
    dialogSure() {
      // 关闭弹窗
      this.dialog.show = false
      setTimeout(() => {
        this.dialog.ulMsgShow = false
      }, 200)
      if (this.activeSuccess) {
        this.reload() // 成功后刷新
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/comCouRecStyle.less';
</style>
